





















































import { Component, Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';
import Loading from '@/components/Loading.vue';

interface ICenterWithHealth {
  centerCode: string;
  name: string;
  health: {
    updatedAt: string;
    status: 'OK' | 'INFO' | 'WARN' | 'SEVERE';
    reason: string;
  };
}

interface IOverallHealth {
  percentUp: string;
  numberDown: number;
}

@Component({
  components: {
    Loading,
  },
})
export default class Reports extends Vue {
  public healthQuery = gql`
    query Health {
      centers {
        centerCode
        name
        health {
          updatedAt
          status
          reason
        }
      }
    }
  `;

  public centers: ICenterWithHealth[] | null = null;

  public getDate(center: ICenterWithHealth): string {
    return new Date(center.health.updatedAt).toLocaleString();
  }

  public getHealthStr(center: ICenterWithHealth): string {
    return (center.health && center.health.status.toLowerCase()) || 'info';
  }

  public getOverallHealth(
    centers: ICenterWithHealth[] | null,
  ): IOverallHealth | null {
    if (!centers) {
      return null;
    }

    const centersUp = centers.filter(
      (c) => ['ok', 'info'].indexOf(c.health.status.toLowerCase()) > -1,
    );

    return {
      percentUp: ((centersUp.length / centers.length) * 100).toFixed(2) + '%',
      numberDown: centers.length - centersUp.length,
    } as IOverallHealth;
  }
}
